<template>
  <v-container>
    <v-card class="pa-16">
      <v-card-title>
        <v-row>
          <v-col cols="6" md="6" justify="center">
            <h3>
              {{ titleheader }}
              <v-btn v-if="this.add_h.inv_type == 'P'" @click="openconverttoinv()" color="#484848"
                class="mb-2 white--text">
                <span>Convert to Invoice</span>
              </v-btn>
            </h3>
          </v-col>
          <v-col cols="6" md="6">
            <v-row>
              <v-col class="text-right" cols="12" md="12">
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <h5>No. {{ showinv_id }}</h5>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <h5>
                      <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                        transition="scale-transition" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :disabled="datainv_disable" class="mt-n7" v-model="computedDateFormatted"
                            label="Date." append-icon="mdi-calendar" readonly disabled dense outlined v-bind="attrs"
                            v-on="on"></v-text-field>
                        </template>

                        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </h5>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <v-col class="text-right" cols="12" md="4">
                    <v-text-field :disabled="datainv_disable" class="mt-n10" label="Period_cover" v-model="period_cover"
                      outlined dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="end">
                  <!--  v-if="datainv_disable" -->
                  <v-btn depressed class="mx-2" color="blue darken-1" outlined @click="getselecttitle()">
                    print Invoice
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-title>

      <v-row justify="start">
        <v-col class="text-right" cols="12" md="4">
          <v-text-field disabled class="" label="Creator" v-model="getaccount_userid" outlined dense></v-text-field>
        </v-col>
        <v-col class="text-right" cols="12" md="4">
          <!-- :disabled="disabled_dep" -->
          <v-autocomplete disabled class="" :items="department_list" label="For Department" item-text="department_name"
            item-value="id" v-model="getdatefrom_inv_h.dept" outlined dense></v-autocomplete>
        </v-col>
      </v-row>

      <br />
      <div id="tabs" class="containertab">
        <div class="tabs">
          <a v-on:click="activetab = 1" v-bind:class="[activetab === 1 ? 'active' : '']">Service</a>
          <a class="ml-1" v-on:click="activetab = 2" v-bind:class="[activetab === 2 ? 'active' : '']">Timesheet</a>
          <a class="ml-1" v-on:click="activetab = 3" v-bind:class="[activetab === 3 ? 'active' : '']">Advance</a>
          <a class="ml-1" v-on:click="activetab = 4" v-bind:class="[activetab === 4 ? 'active' : '']">Miscellaneous
            disbursements</a>
          <!-- <a
              class="ml-1"
              v-on:click="activetab = 5"
              v-bind:class="[activetab === 5 ? 'active' : '']"
              >Additional Note</a
            > -->
        </div>

        <div class="content">
          <div v-if="activetab === 1 && callsoopentab == true" class="tabcontent">
            <InvoiceSalseorderTab :vat_cus="vat_cus" :payment_term_cus="payment_term_cus" :po_no_cus="po_no_cus"
              :attention_cus="attention_cus" :contact_position_cus="contact_position_cus" :vat_type_cus="vat_type_cus"
              :datainv_disable="datainv_disable" :so_id="this.$route.params.id" :datainv_h="getdatefrom_inv_h"
              :datainv_so="getdatefrom_inv_so" @inv_sotab_isheader="getdatafromSOisheader"
              @inv_sotab_noheader="getdatafromSOcomponent" @inv_sotab_tabledesserts="getdatafromSOtable"
              @inv_sotab_vatcus="getdatavatcus" @inv_sotab_paymentcus="getdatapaymentcus"
              @inv_sotab_ponocus="getdataPonoCus" @inv_sotab_attentioncus="getdataAttentionCus"
              @inv_sotab_contact_positioncus="getdatacontact_positionCus" @inv_sotab_vat_type="getdatavat_type">
            </InvoiceSalseorderTab>
          </div>
          <div v-if="activetab === 2" class="tabcontent">
            <InvoiceTimesheetTab :tsTAB_IdforCus="this.$route.params.id" :getdataByCusStatus="getdataByCusStatus"
              :disableinstatus="disableinstatus" :ts_status_oper="ts_status_oper" :ts_idTab="ts_idTab"
              :selected_showE="selected_showE" :oper_sel="oper_sel" :cus_invts="this.inv_ts_list"
              :mode_oper_ts="this.mode_oper" @getdatafromTStotal="getdatafromTStotal" @getTsIdTab="getTsId"
              @getSelected_showETab="getSelected_showE" @getOper_selTab="getOper_sel" @getInvTsListTab="getInvTsList"
              @getmode_oper_tsTab="getmode_oper_ts"></InvoiceTimesheetTab>
          </div>
          <div v-if="activetab === 3" class="tabcontent">
            <InvoiceAdvanceTab :tsTAB_IdforCus="this.$route.params.id" :getdataByCusStatus="getdataByCusStatus"
              :disableinstatus="disableinstatus" :ts_status_oper="ts_status_oper" :ad_idTab="ad_idTab"
              :selected_showAv="selected_showAv" :oper_sel_Av="oper_sel_Av" @getSelected_showAvTab="getSelected_showEAv"
              @getOper_sel_avTab="getOper_selAv" @getdatafromAdtotal="getdatafromAdtotal" @getAdIdTab="getAdId"
              @getAdInvioceIdTab="getAdInvioceId"></InvoiceAdvanceTab>
          </div>
          <div v-if="activetab === 4" class="tabcontent">
            <InvoiceMiscellaneousTab :datainv_disable="datainv_disable" :datainv_mis="datainv_mis"
              @inv_mistab_data="getdatafromMis"></InvoiceMiscellaneousTab>
          </div>
          <!-- <div v-if="activetab === 5" class="tabcontent">
              <AdditionalNoteTab
                :datainv_disable="datainv_disable"
                :datainv_additional_top="add_h.additional_top"
                :datainv_additional_bottom="add_h.additional_bottom"
                @inv_additionaltab_data="getdatafromadditional"
              ></AdditionalNoteTab>
            </div> -->
        </div>
      </div>

      <v-row justify="center" align="center">
        <v-col cols="12" md="12">
          <v-row>
            <div align="center" class="width16">
              <h5>Service Total</h5>
              <v-text-field reverse v-model="so_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Timesheet Total</h5>
              <v-text-field reverse v-model="ts_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Advance Total</h5>
              <v-text-field reverse v-model="ad_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthplus font-weight-black mt-7">
              <span> + </span>
            </div>

            <div align="center" class="width16">
              <h5>Miscellaneous Total</h5>
              <v-text-field reverse v-model="mis_total" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
            <div justify="center" align="center" class="widthsub font-weight-black mt-7">
              <span> = </span>
            </div>

            <div align="center" class="widthsubtotal">
              <h5>Sub Total</h5>
              <v-text-field reverse v-model="inv_subtotal" outlined dense background-color="#F5F5F5"
                disabled></v-text-field>
            </div>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-row>
            <v-col cols="12" md="12">
              Upload File
              <span class="red--text">(Support .pdf files only) </span>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="12" md="12">
              <input type="file" accept="application/pdf" @change="previewMultiImage" class="inputsize" ref="filefile"
                style="display: none" multiple="multiple" />
              <v-btn :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }" class="widthbtnimagefile" @click="$refs.filefile.click()" elevation="7">
                <v-icon left dark color="white"> mdi-cloud-upload </v-icon>
                Upload file
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" align="start">
              <v-row>
                <v-col cols="12" md="12" align="start">
                  <h5>
                    <v-row>
                      <v-col cols="12" md="3" align="start">
                        Files Name:
                      </v-col>
                      <v-col cols="12" md="8" align="start">
                        <span v-for="(item, index) in this.filename" :key="index">
                          <a @click="popuppreviewfile(index)" :style="{
                            color: '#43a047',
                          }">
                            {{ item }}</a>

                          <v-btn :style="{
                            backgroundColor: '#FFEBEE',
                            color: '#F44336',
                          }" small icon @click="popupdeletefile(index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <br />
                        </span>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="3" align="start">
                        Files Name(Old) :
                      </v-col>
                      <v-col cols="12" md="8" align="start" v-if="filename_old.length > 0">
                        <span v-for="(item, index) in this.filename_old" :key="index">
                          <a @click="previewnoticefilepdf(item)" :style="{
                            color: '#43a047',
                          }">
                            {{ item }}</a>

                          <v-btn :style="{
                            backgroundColor: '#FFEBEE',
                            color: '#F44336',
                          }" small icon @click="popupdeletefile_old(index)">
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <br />
                        </span>
                      </v-col>
                    </v-row>
                  </h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-5">
              <p>Less Withholding Tax</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthlesspersen">
              <v-text-field :disabled="datainv_disable" reverse @keyup="calwth_rate" v-model="wth_rate" outlined
                dense></v-text-field>
            </div>
            <div justify="center" align="center" class="widthtextpersen font-weight-black mt-5">
              <h5 class="body-1 font-weight-black">% =</h5>
            </div>
            <div align="center" class="widthlesstotal">
              <v-text-field reverse v-model="wth_ratetotal" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>

          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-5">
              <p>Vat</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthlesspersen">
              <v-text-field :disabled="datainv_disable" reverse @keyup="caltax_rate" v-model="tax_rate" outlined
                dense></v-text-field>
            </div>
            <div justify="center" align="center" class="widthtextpersen font-weight-black mt-5">
              <h5 class="body-1 font-weight-black">% =</h5>
            </div>
            <div align="center" class="widthlesstotal">
              <v-text-field reverse v-model="tax_ratetotal" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>

          <v-row>
            <div align="center" class="widthgrandnull"></div>
            <div justify="center" align="right" class="widthglessword font-weight-black mt-5">
              <p>Grand Total</p>
            </div>
            <div class="widthspace"></div>

            <div align="center" class="widthsubtotalG">
              <v-text-field reverse v-model="amount_total" outlined background-color="#F5F5F5" disabled
                dense></v-text-field>
            </div>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mt-5">
        <v-col align="center" cols="12" md="12" v-if="this.statuscheck != 'Cancel'">
          <v-btn :disabled="datainv_disable" depressed class="mr-5 buttonblue btn-width"
            @click="saveinvDraftandSubmit('Update')">
            Update Data
          </v-btn>
          <v-btn :disabled="datainv_disable" depressed class="buttonred btn-width" @click="dialogDeleteForm = true">
            VOID INVOICE
          </v-btn>
          <!-- <v-btn depressed>
                  Cancel Request
                </v-btn> -->
        </v-col>
      </v-row>
      <template>
        <!-- 
            v-for="index in datashowAll.length"
            v-if="datashowAll.length >= 0 || pageAll >= 0" -->
        <!--   :style="showprint" -->
        <div v-if="datashowAll.length >= 0 || pageAll >= 0" id="mydivhtmltobase" :style="showprint">
          <PrintInvoiceDejTab v-if="getcompany_id == 1" :datashowAll="datashowAll" :print_header="print_header"
            :heighttabledetail="heighttabledetail" :company_inv_prindej="company_inv_prindej"
            :datashowAlltimesheet="datashowAlltimesheet" :haveSO="haveSO" :showcurrency="showcurrency"
            :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
            :datashowAlltimekeeper="datashowAlltimekeeper" :checklawoffice="checklawoffice"></PrintInvoiceDejTab>
          <PrintInvoiceStandardTab v-if="getcompany_id !== 1" :datashowAll="datashowAll" :print_header="print_header"
            :heighttabledetail="heighttabledetail" :datashowAlltimesheet="datashowAlltimesheet" :haveSO="haveSO"
            :showcurrency="showcurrency" :check_cus_name="check_cus_name" :textamount_total_en="textamount_total_en"
            :datashowAlltimekeeper="datashowAlltimekeeper" :checklawoffice="checklawoffice"></PrintInvoiceStandardTab>
        </div>
      </template>

      <v-dialog v-model="dialogDeleteForm" max-width="350px">
        <v-card>
          <v-card-title class="text-h6">Are you sure void this invoice?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteForm">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirmForm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row justify="center">
        <v-dialog v-model="dialogSelectTitle" scrollable max-width="300px">
          <!-- <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark v-bind="attrs" v-on="on">
                Open Dialog
              </v-btn>
            </template> -->
          <v-card>
            <v-card-title>Select Document Type</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: auto">
              <v-radio-group v-model="dialogSelectTitleData" column>
                <v-radio label="Statement" value="1" se></v-radio>
                <v-radio label="Invoice" value="2"></v-radio>
                <v-radio label="Proforma Invoice" value="3"></v-radio>
              </v-radio-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" outlined @click="dialogSelectTitle = false">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" outlined @click="toprintfromselecttitle">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="dialogconverttoinv" max-width="300px">
          <v-card>
            <v-card-title style="padding: 0px">
              <span class="text-h5 justify-center"></span>
              <v-spacer></v-spacer>
              <v-btn @click="dialogconverttoinv = false" icon>
                <v-icon large>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-title class="text-h6 justify-center">
              <span class="text-h5 justify-center">Are you sure?</span>
              <span> You cannot undo this later</span></v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" outlined @click="dialogconverttoinv = false">Cancel</v-btn>
              <v-btn color="blue darken-1" outlined @click="confirmconverttoinv">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete_old" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete_old">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm_old">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <PdfPreviewDialog v-model="dialogPDF" :blob="pdfBlob" :filename="getFileName()" />
      
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import api from "@/services/api";
import { server, INVUrl } from "@/services/constants";
import InvoiceSalseorderTab from "./InvoiceSalseorderTab";
import InvoiceTimesheetTab from "./InvoiceTimesheetTab";
import InvoiceAdvanceTab from "./InvoiceAdvanceTab";
import InvoiceMiscellaneousTab from "./InvoiceMiscellaneousTab";
import AdditionalNoteTab from "./AdditionalNoteTab";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import PrintInvoiceDejTab from "./PrintInvoiceDejTab";
import PrintInvoiceStandardTab from "./PrintInvoiceStandardTab";
var convert = require("decimal-number-to-words");
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";
import pdfInvoiceGenerator from "@/utils/pdfInvoiceGenerator";
const moment = require("moment-timezone");
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
  async beforeMount() {
    this.$showLoader();
    this.caltotalAll();
    if (this.$route.params.mode == "invoice") {
      this.titleheader = "Invoice";
      this.add_h.inv_type = "I";
      this.callsoopentab = true;
    } else if (this.$route.params.mode == "performa") {
      this.titleheader = "Proforma Invoice";
      this.add_h.inv_type = "P";
      this.callsoopentab = true;
    } else {
      this.getdatafrominv_h = true;
      this.loaddatainv();
    }
    await this.loadDepartmentByCompanyId();
    this.$hideLoader();
  },
  async mounted() {
    this.$showLoader();
    this.caltotalAll();
    // this.$showLoader();
    if (this.$route.params.mode == "invoice") {
      this.titleheader = "Invoice";
      this.add_h.inv_type = "I";
      this.add_h.company_inv = this.$route.params.company_inv;
      this.callsoopentab = true;
    } else if (this.$route.params.mode == "performa") {
      this.titleheader = "Proforma Invoice";
      this.add_h.inv_type = "P";
      this.add_h.company_inv = this.$route.params.company_inv;
      this.callsoopentab = true;
    } else {
      this.getdatafrominv_h = true;
      await this.loaddatainv();
    }
    await this.loadDepartmentByCompanyId();
    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    InvoiceSalseorderTab,
    InvoiceTimesheetTab,
    InvoiceAdvanceTab,
    InvoiceMiscellaneousTab,
    AdditionalNoteTab,
    PrintInvoiceDejTab,
    PrintInvoiceStandardTab,
    PdfPreviewDialog,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedDateFormatted() {
      return unity.formatDate(this.date);
    },

    // ====================================================================
    // Computed properties สำหรับ PDF (เพิ่มใน computed section)
    // หรือถ้าไม่มี computed ให้สร้าง getter functions แทน
    // ====================================================================
    header() {
      return this.statementData?.print_header || {};
    },

    // items() {
    //   if (
    //     this.statementData?.datashowAll &&
    //     this.statementData.datashowAll.length > 0
    //   ) {
    //     return this.statementData.datashowAll[0] || [];
    //   }
    //   return [];
    // },

    items() {
      if (
        this.statementData?.datashowAll &&
        this.statementData.datashowAll.length > 0
      ) {
        // ← รวมทุกหน้าเข้าด้วยกัน
        return this.statementData.datashowAll.flat() || [];
      }
      return [];
    },

    subtotal() {
      return this.header.sub_total || 0;
    },

    withholdingTax() {
      return this.header.wth_rate_amount || 0;
    },

    vat() {
      return this.header.tax_rate_amount || 0;
    },

    grandTotal() {
      return this.header.amount_total || 0;
    },

    withholdingTaxRate() {
      return this.header.wth_rate || "3.00";
    },

    vatRate() {
      return this.header.tax_rate || "7.00";
    },

    currency() {
      return this.statementData?.showcurrency || "USD";
    },

    dynamicItemsPerPage() {
      const totalItems = this.items.length;
      // ถ้าไม่เกิน 8 บรรทัด ใช้ 8, ถ้ามากกว่าใช้ 13
      return totalItems <= 8 ? 8 : 13;
    },
  },
  data() {
    return {
      pdfBlob: null,
      pdfObj:null,
      dialogPDF:false,
      textamount_total_en: "",
      // เพิ่มตัวแปรใหม่สำหรับ pdfMake
      statementData: null, // เก็บข้อมูลสำหรับสร้าง PDF
      pdfMakeReady: false, // เช็คว่า pdfMake โหลดเสร็จหรือยัง

      getcompany_id: localStorage.getItem(server.COMPANYID),
      check_cus_name: false,
      preview_list2: [],
      getpreview_list: [],
      image: null,
      previewimage: null,
      previewimageedit: null,
      image_list: [],
      preview_list: [],
      dialogpreviewimage: false,
      checkfileapreview: false,
      previewpopupfile: [],
      previewpopupfile2: [],
      dialogpreviewfile: false,
      dialogDelete: false,
      dialogDelete_old: false,
      dialogDeleteimage: false,
      filename: [],
      filename_old: [],
      delfilename_old: [],
      imagename: "",
      load_bg: false,
      checkfileadd: false,
      checkimageadd: false,
      old_index: -1,
      //--
      mode_oper: "edit",
      po_no_cus: "",
      attention_cus: "",
      contact_position_cus: "",
      contact_position: "",
      vat_type: "",
      vat_type_cus: "",
      vat_cus: 0,
      payment_term_cus: 0,
      selected_showE: [],
      oper_sel: 1,
      selected_showAv: [],
      oper_sel_Av: 1,
      callsoopentab: false,
      dialogDeleteForm: false,
      datainv_disable: false,
      showinv_id: "####",
      menu2: false,
      desserts: [],
      getdatefrom_inv_so: [],
      getdatafrominv_h: false,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      addinv_docref_so: {
        inv_hid: 0,
        ref_type: "SO",
        ref_id: 0,
      },
      addinv_docref_ts: {
        inv_hid: 0,
        ref_type: "TS",
        ref_id: 0,
      },
      addinv_docref_ad: {
        inv_hid: 0,
        ref_type: "AD",
        ref_id: 0,
      },
      addinv_so: {
        inv_hid: 0,
        so_seq: 0,
        item_id: "",
        item_name: "",
        item_qty: 0,
        item_um: "",
        item_price: 0,
        item_disc: 0,
        item_line_amt: 0,
        user_create: localStorage.getItem(server.USER_ID),
      },
      getdatefrom_inv_h: {
        customerid: 0,
        customer_code: "",
        customer_name: "",
        customer_address: "",
        customer_taxid: "",
        customer_branch: "",
        customer_paymentterm: 0,
        customer_vat: 0,
        vat_type: "",
        saleorder_id: "",
        currency: "",
      },
      period_cover: "",
      wth_rate: 0,
      tax_rate: 0,
      wth_ratetotal: 0,
      tax_ratetotal: 0,
      amount_total: 0,
      invoice_address: "",
      so_total: this.$store.state.inv_so_total,
      ts_total: 0,
      ad_total: this.$store.state.inv_advance_total,
      mis_total: this.$store.state.inv_miscellaneous_total,
      inv_subtotal: 0,
      titleheader: "Invoice",
      activetab: 1,
      isShowPassword: false,
      fullPage: true,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      add_h: {
        inv_id: "",
        pinv_id: "",
        company_id: localStorage.getItem(server.COMPANYID),
        inv_date: "",
        period_cover: "",
        inv_type: "",
        customerid: 0,
        customer_address: "",
        customer_taxid: "",
        customer_branch: "",
        customer_paymentterm: 0,
        customer_vat: 0,
        vat_type: "",
        so_total: 0,
        ts_total: 0,
        ad_total: 0,
        mis_total: 0,
        sub_total: 0,
        wth_rate: 0,
        tax_rate: 0,
        amount_total: 0,
        company_inv: "",
        so_ref: 0,
        additional_top: "",
        additional_bottom: "",
        po_no: "",
        attention: "",
        user_create: localStorage.getItem(server.USER_ID),
      },
      disableinstatus: true,
      ts_status_oper: "draft",
      tsTAB_IdforCus: this.$route.params.id,
      getdataByCusStatus: "",
      ts_id: [],
      ad_id: [],
      ts_idTab: [],
      ad_idTab: [],
      ts_idTab: 0,
      datainv_mis: [],
      ad_inv_id: [],
      id_invoice: 0,
      print_header_list: [
        {
          id: "1",
          com_title: "STATEMENT",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
          customer_paymentterm: "0",
          credit_term_date: "",
        },
        {
          id: "2",
          com_title: "STATEMENT",
          com_name: "",
          inv_company_name_th: "",
          inv_company_address: "",
          inv_company_branch: "",
          inv_company_tel: "",
          inv_company_email: "",
          inv_tax_id: "",
          com_eng_1: "DEJ-UDOM & ASSOCIATES",
          com_eng_2: "ATTORNEYS AT LAW",
          com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
          com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,",
          com_add_no: "942/69 RAMA IV ROAD,",
          com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,",
          com_add_country: "BANGKOK 10500, THAILAND",
          com_add_tel: "Tel : 0-2233-0055, 0-2267-5152",
          com_add_fax: "Fax : 0-2236-6681, 0-2233-0227",
          com_add_email: "E-MAIL : account@dejudom.com",
          com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
          customer_paymentterm: "0",
          credit_term_date: "",
        },
      ],
      print_header: {},
      print_table_detail: [],
      pageAll: 1,
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      opensummarizetimesheet: false,
      pageAlltimesheet: 1,
      setdatatoshowtimesheet: [],
      print_table_detailtimesheet: [],
      datashowAlltimesheet: [],
      print_detail_timekeeper: [],
      datashowAlltimekeeper: [],
      showprint: "display:none;",
      haveSO: false,
      haveAD: false,
      indexinvADMIS: false,
      showcurrency: "",
      dialogSelectTitleData: "1",
      dialogSelectTitle: false,
      dialogconverttoinv: false,
      inv_ts_list: [],
      checklawoffice: false,
      heighttabledetail: "546px",
      company_inv_prindej: "",
      disabled_dep: false,
      department_list: [],
      getaccount_userid: [],
      getuser_create: 0,
      statuscheck: "",
    };
  },
  methods: {
            getFileName() {
  return `${this.dialogSelectTitleData == '1'?'Statement_':this.dialogSelectTitleData == '2'?'Invoice_':this.dialogSelectTitleData == '3'?'Proforma_Invoice_':'Invoice_'}${this.print_header.inv_id??''}.pdf`
},
    async loadDepartmentByCompanyId() {
      let result = await api.billing_expense_getAllDepartment_By_CompanyID(
        localStorage.getItem(server.COMPANYID)
      );
      this.department_list = result.data;

      if (!this.getuser_create) {
        return;
      }
      const res_user = await api.getAccountid(Number(this.getuser_create));
      if (res_user?.data?.length > 0) {
        this.getaccount_userid = res_user.data[0].firstname
          ? `${res_user.data[0].firstname} ${res_user.data[0].lastname}`
          : `${res_user.data[0].firstname_e_n} ${res_user.data[0].lastname_e_n}`;

        if (
          Number(res_user.data[0].department_i_d) != 6 &&
          Number(this.getuser_create) != 1
        ) {
          this.disabled_dep = true;
        } else {
          this.disabled_dep = false;
        }
      }
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async openconverttoinv() {
      this.dialogconverttoinv = true;
    },
    async confirmconverttoinv() {
      this.$showLoader()
      const result_converttoinv = await api.billing_expense_updateInvoice_H_Geninv_id(
        this.$route.params.id,
        {
          company_inv: this.add_h.company_inv,
          old_company_inv: this.add_h.company_inv,
          inv_type: "I",
          company_id: this.add_h.company_id,
          inv_date: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD"),
        }
      );
      if (
        result_converttoinv.status == 200 ||
        result_converttoinv.status == 201
      ) {
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Convert to Invoice",
          "Convert to Invoice successfully",
          "text-h5 green--text text-center",
          `/edit-invoice/${this.$route.params.id}/inv_h/edit`
        );
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Convert to Invoice",
          "Convert to Invoice Failed ",
          "text-h5 red--text text-center"
        );
      }
      this.dialogconverttoinv = false;
    },
    async getselecttitle() {
      if (
        localStorage.getItem(server.COMPANYID) == "1" ||
        localStorage.getItem(server.COMPANYID) == 1
      ) {
        this.dialogSelectTitleData = "1";
        this.dialogSelectTitle = true;
      } else {
        await this.getPrintOutData();
      }
    },
    async toprintfromselecttitle() {
      if (this.dialogSelectTitleData == "1") {
        this.print_header_list[0].com_title = "STATEMENT";
        this.print_header_list[1].com_title = "STATEMENT";
      } else if (this.dialogSelectTitleData == "2") {
        this.print_header_list[0].com_title = "INVOICE";
        this.print_header_list[1].com_title = "INVOICE";
      } else if (this.dialogSelectTitleData == "3") {
        this.print_header_list[0].com_title = "Proforma Invoice";
        this.print_header_list[1].com_title = "Proforma Invoice";
      } else {
        this.print_header_list[0].com_title = "";
        this.print_header_list[1].com_title = "";
      }

      await this.getPrintOutData();
      this.dialogSelectTitle = false;
    },
    async getPrintOutData() {
      // console.log(this.id_invoice);
      this.inv_id = this.id_invoice;
      // this.showprint = "";
      this.haveSO = false;
      this.haveAD = false;
      this.datashowAll = [];
      this.print_table_detail = [];
      this.print_table_detailtimesheet = [];
      this.print_detail_timekeeper = [];
      this.dialogPrintOut = false;
      // alert(`Print Out Invoice ID: ${this.inv_id}, ${this.dialogPrintOutData}`);
      // if (this.dialogPrintOutData == "1") {
      //   this.print_header = this.print_header_list[0];
      // } else if (this.dialogPrintOutData == "2") {
      //   this.print_header = this.print_header_list[1];
      // }
      // console.log("print_header:", JSON.stringify(this.print_header));
      this.$showLoader();

      await this.loadRef_TypeCNById();
      await this.loadInvSoData();
      // await this.loadMainInvSoData();
      // await this.loadInvADData();
      await this.loadInvDocRefData();
      await this.loadInvTSGetTimekeeper();
      await this.loadInvMISData();
      await this.checkcontent();
      await this.checkcontenttimesheet();
      // await this.exportToPDF();
      await this.exportToPDFBypdfMake();
      // this.showprint = "display:none;";
      this.$hideLoader();
    },

    // ====================================================================
    // ฟังชั่นใหม่: exportToPDFBypdfMake
    // คัดลอกโค้ดทั้งหมดนี้ไปวางในส่วน methods ของไฟล์ Invoice.vue
    // ====================================================================

    async exportToPDFBypdfMake(advance_id) {
      // เตรียมข้อมูลสำหรับปริ้น
      let main_data_to_print = {
        main_data: {
          datashowAll: this.datashowAll,
          print_header: this.print_header,
          heighttabledetail: this.heighttabledetail,
          company_inv_prindej: this.company_inv_prindej,
          datashowAlltimesheet: this.datashowAlltimesheet,
          haveSO: this.haveSO,
          showcurrency: this.showcurrency,
          check_cus_name: this.check_cus_name,
          textamount_total_en: this.textamount_total_en,
          datashowAlltimekeeper: this.datashowAlltimekeeper,
          checklawoffice: this.checklawoffice,
        },
      };

      // เก็บข้อมูลไว้ใน this.statementData เพื่อให้ฟังชั่นอื่นเข้าถึงได้
      this.statementData = main_data_to_print.main_data;

      // console.log(`statementData:${JSON.stringify(this.statementData)}`);

      // รอให้ pdfMake พร้อมใช้งาน
      try {
        await this.waitForPdfMakeReady();
          //ฟังก์ชันปริ้นใหม่
        // await pdfInvoiceGenerator.exportToPDF(this.statementData);

            // ฟังก์ชันปริ้นใหม่
            const blob = await pdfInvoiceGenerator.exportToPDF(this.statementData);
            this.pdfBlob = blob;
            this.dialogSelectTitle = false;
            this.dialogPDF = true;
      } catch (error) {
        console.error("❌ pdfMake ไม่พร้อมใช้งาน:", error);
        alert("ไม่สามารถโหลดระบบ PDF ได้ กรุณาลองใหม่อีกครั้ง");
        return;
      }

      // สร้าง PDF
      // try {
      //   const docDefinition = this.generateCombinedDocDefinitionForInvoice();

      //   // เปิด PDF ใหม่ในแท็บใหม่
      //   pdfMake.createPdf(docDefinition).open();
      //   console.log("✅ สร้าง PDF สำเร็จ (ORIGINAL + COPY)");
      // } catch (error) {
      //   console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
      //   alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      // }
    },

    // ====================================================================
    // ฟังชั่นรอให้ pdfMake พร้อมใช้งาน
    // ====================================================================
    waitForPdfMakeReady() {
      return new Promise((resolve, reject) => {
        const checkInterval = setInterval(() => {
          if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
            clearInterval(checkInterval);
            console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
            resolve(true);
          }
        }, 100);

        setTimeout(() => {
          clearInterval(checkInterval);
          reject(new Error("pdfMake โหลดไม่สำเร็จ"));
        }, 10000);
      });
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตตัวเลข
    // ====================================================================
    formatNumber(value) {
      if (!value && value !== 0) return "0.00";
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    // ====================================================================
    // ฟังชั่นจัดฟอร์แมตวันที่
    // ====================================================================
    formatDate(dateString) {
      if (!dateString) return "";
      if (dateString.includes("/")) {
        return dateString;
      }

      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    // ====================================================================
    // ฟังชั่นสร้างส่วนผลรวมและ footer (ใช้เฉพาะหน้าสุดท้าย)
    // คัดลอกมาจาก StatementpdfV3.vue เป๊ะๆ
    // ====================================================================
    // ====================================================================
    // ฟังชั่นสร้างเนื้อหาหลักของ Statement (ปรับปรุงแล้ว)
    // ====================================================================

    generateSummaryAndFooter() {
      return [
        // ตารางสรุปยอดเงิน
        {
          table: {
            widths: ["*", 120],
            body: [
              [
                {
                  text: "Sub Total / รวมเป็นเงิน",
                  fontSize: 10,
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.subtotal) + " " + this.currency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, true, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Less Withholding Tax / ภาษีหัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text:
                    this.formatNumber(this.withholdingTax) +
                    " " +
                    this.showcurrency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                  fontSize: 10,
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
                {
                  text: this.formatNumber(this.vat) + " " + this.currency,
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                  margin: [5, 3, 5, 3],
                },
              ],
              [
                {
                  text: "Grand Total / ยอดรวม",
                  fontSize: 10,
                  bold: true,
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
                {
                  text:
                    this.formatNumber(this.grandTotal) +
                    " " +
                    this.showcurrency,
                  fontSize: 10,
                  bold: true,
                  alignment: "right",
                  border: [true, false, true, true],
                  margin: [5, 3, 5, 3],
                },
              ],
            ],
          },
          layout: {
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 5],
        },

        // จำนวนเงินตัวอักษร
        {
          text: `(${this.statementData.textamount_total_en || ""}) ${this.currency
            }`,
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 5, 0, 10],
        },

        // ข้อความ Please send
        {
          stack: [
            {
              text:
                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 10],
            },
          ],
        },

        // Disclaimer
        {
          stack: [
            {
              text: "Cybersecurity & Wire Transfer Disclaimer",
              fontSize: 8,
              bold: true,
              color: "red",
              margin: [0, 0, 0, 2],
            },
            {
              text:
                "Dej-Udom & Associates Ltd. shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates Ltd. for verification if in doubt.",
              fontSize: 7,
              color: "red",
              alignment: "justify",
            },
          ],
        },
      ];
    },

    // ====================================================================
    // ฟังชั่นสร้างเนื้อหาหลักของ Statement
    // คัดลอกมาจาก StatementpdfV3.vue เป๊ะๆ
    // ====================================================================
    generateMainStatement(documentType = "ORIGINAL") {
      const mainContent = [];
      const itemsPerPage = this.dynamicItemsPerPage; // ใช้ค่าแบบไดนามิก

      // ตรวจสอบชื่อบริษัทเพื่อกำหนดข้อความ Disclaimer
      const isLawOffice =
        this.header.com_thai === "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์";
      // console.log(`isLawOffice: ${isLawOffice}`);
      const disclaimerText = isLawOffice
        ? "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt."
        : "Dej-Udom & Associates Ltd. shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates Ltd. for verification if in doubt.";
      // console.log(`disclaimerText: ${disclaimerText}`);

      // ตรวจสอบภาษาของ customer_name เพื่อกำหนดรูปแบบจำนวนเงินตัวอักษร
      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      const isThaiCustomer = checker_th.test(this.header.customer_name || "");

      // กำหนดข้อความจำนวนเงินตัวอักษร
      let amountInWords = "";
      if (isThaiCustomer) {
        // ถ้าชื่อลูกค้าเป็นภาษาไทย → แสดงจำนวนเงินเป็นภาษาไทย
        amountInWords = this.statementData.textamount_total_en || "";
      } else {
        // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ → แสดงจำนวนเงินเป็นภาษาอังกฤษ พร้อม currency
        amountInWords = `(${this.statementData.textamount_total_en || ""}) ${this.currency
          }`;
      }

      //replace US to USD
      amountInWords = amountInWords.replace("US", "USD");
      amountInWords = amountInWords.replace("USDD", "USD");
      // console.log(`amountInWords: ${amountInWords}`);

      // ===== หน้าที่ 1 =====
      mainContent.push(
        // Header บริษัท
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 1],
                },
                {
                  text: this.header.com_eng_2 || "ATTORNEYS AT LAW",
                  fontSize: 9,
                  margin: [0, 0, 0, 2],
                },
                {
                  text:
                    this.header.com_thai ||
                    "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                  fontSize: 11,
                  margin: [0, 0, 0, 1],
                },
              ],
            },
            {
              width: "50%",
              stack: [
                {
                  text:
                    this.header.com_add_name ||
                    "CHARN ISSARA TOWER 1, 2nd FLOOR,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_city ||
                    "KWAENG SURIYAWONG, KHET BANGRAK,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_country || "BANGKOK 10500, THAILAND",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tel || "Tel : 0-2233-0055, 0-2267-5152",
                  fontSize: 8,
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                },
                {
                  text:
                    this.header.com_add_email || "E-MAIL : account@dejudom.com",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    this.header.com_add_tax_id ||
                    'TAX ID. No. 0105534015348/"HEAD OFFICE"',
                  fontSize: 8,
                  alignment: "right",
                  bold: true,
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // STATEMENT พร้อม ORIGINAL/COPY
        {
          columns: [
            {
              width: "70%",
              text: this.header.com_title || "STATEMENT",
              fontSize: 18,
              bold: true,
            },
            {
              width: "30%",
              stack: [
                {
                  text: documentType,
                  fontSize: 11,
                  bold: true,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `No. / เลขที่ : ${this.header.inv_id || ""}`,
                  fontSize: 10,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // เส้นคั่น
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 545, // ปรับจาก 515 เป็น 545 เพราะ padding น้อยลง
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ข้อมูลลูกค้า
        {
          columns: [
            {
              width: "55%",
              stack: [
                {
                  text: [
                    { text: "To / ถึง:  ", fontSize: 10 },
                    {
                      text: this.header.customer_name || "",
                      fontSize: 10,
                      bold: true,
                    },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: (this.header.addressall || "").split("\n"),
                  fontSize: 9,
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `Tax ID: ${this.header.customer_taxid || "0"}`,
                  fontSize: 9,
                  margin: [0, 3, 0, 2],
                },
                {
                  text: `Attention : ${this.header.attention ||
                    this.header.customer_contact_name ||
                    "-"}`,
                  fontSize: 9,
                },
              ],
            },
            {
              width: "45%",
              stack: [
                {
                  text: `Date / วันที่: ${this.header.invoice_date ? this.header.invoice_date : "-"
                    }`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 8],
                },
                {
                  text: `Period Covered / รอบระยะเวลา : ${this.header
                    .period_cover || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `Document Ref. : ${this.header.docref || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                },
                {
                  text: `Credit Term : ${this.header.customer_paymentterm ||
                    "-"} Days`,
                  fontSize: 9,
                  alignment: "right",
                },
                {
                  text: `Due Date : ${this.header.credit_term_date || "-"}`,
                  fontSize: 9,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // ตาราง หน้า 1 - มีความสูงคงที่ 9 แถว
        {
          table: {
            headerRows: 1,
            widths: ["*", 120],
            heights: (row) => {
              if (row === 0) return "auto"; // header
              return 32; // กำหนดความสูงแต่ละแถว 32pt (ประมาณ 2-3 บรรทัด)
            },
            body: (() => {
              const tableBody = [
                [
                  {
                    text: "Description / รายการ",
                    fontSize: 10,
                    bold: true,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "Amount / จำนวนเงิน",
                    fontSize: 10,
                    bold: true,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ],
              ];

              // เพิ่มรายการจริงจาก items หรือแถวว่างถ้าไม่พอ 9 แถว
              for (let i = 0; i < itemsPerPage; i++) {
                // if (i < this.items.length) {
                //   const item = this.items[i];
                //   tableBody.push([
                //     {
                //       text: item.report_desc || "",
                //       fontSize: 9,
                //       margin: [5, 5, 5, 5],
                //     },
                //     {
                //       text:
                //         item.report_amount && item.report_amount !== 0
                //           ? this.formatNumber(item.report_amount)
                //           : "",
                //       fontSize: 9,
                //       alignment: "right",
                //       margin: [5, 5, 5, 5],
                //     },
                //   ]);
                // }

                if (i < this.items.length) {
                  const item = this.items[i];
                  tableBody.push([
                    {
                      // ← เพิ่มเงื่อนไขตรงนี้
                      text:
                        (item.first_item === 1 && item.report_type === "ADMIS"
                          ? "Miscellaneous Disbursement:\n"
                          : "") + (item.report_desc || ""),
                      fontSize: 9,
                      bold:
                        item.first_item === 1 && item.report_type === "ADMIS",
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text:
                        item.report_amount && item.report_amount !== 0
                          ? this.formatNumber(item.report_amount)
                          : "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]);
                } else {
                  // แถวว่าง
                  tableBody.push([
                    {
                      text: "",
                      fontSize: 9,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text: "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]);
                }
              }

              // *** แก้ไข: เพิ่มแถว IMPORTANT เฉพาะเมื่อ currency ไม่ใช่ THB ***
              if (this.currency !== "THB") {
                tableBody.push([
                  {
                    text:
                      "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes;\nwe will solely be responsible for Thai tax.",
                    fontSize: 8,
                    italics: true,
                    bold: true,
                    margin: [5, 5, 5, 5],
                  },
                  {},
                ]);
              } else {
                // แถวว่าง
                tableBody.push([
                  {
                    text: "",
                    fontSize: 9,
                    margin: [5, 5, 5, 5],
                  },
                  {
                    text: "",
                    fontSize: 9,
                    alignment: "right",
                    margin: [5, 5, 5, 5],
                  },
                ]);
              }

              return tableBody;
            })(),
          },
          layout: {
            hLineWidth: function (i, node) {
              // แสดงเส้นบนสุด (i=0), เส้นใต้ header (i=1), และเส้นล่างสุด
              if (i === 0 || i === 1 || i === node.table.body.length) {
                return 1;
              }
              return 0;
            },
            vLineWidth: function (i) {
              return 1;
            },
            paddingLeft: function () {
              return 0;
            },
            paddingRight: function () {
              return 0;
            },
            paddingTop: function () {
              return 0;
            },
            paddingBottom: function () {
              return 0;
            },
          },
          margin: [0, 0, 0, 0],
        }
      );

      // ===== หน้าที่ 2+ ของ Statement (ถ้ามีข้อมูลเกิน 15 รายการ) =====
      const remainingItems = this.items.length - itemsPerPage;

      if (remainingItems > 0) {
        const itemsPerContinuedPage = 20; // ลดจาก 25 เป็น 20 เพื่อไม่ให้เกินกระดาษ
        const additionalPages = Math.ceil(
          remainingItems / itemsPerContinuedPage
        );

        for (let page = 0; page < additionalPages; page++) {
          const startIdx = itemsPerPage + page * itemsPerContinuedPage;
          const endIdx = Math.min(
            startIdx + itemsPerContinuedPage,
            this.items.length
          );
          const isLastPage = endIdx === this.items.length;

          mainContent.push(
            { text: "", pageBreak: "before" },

            {
              text: "STATEMENT (Continued)",
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 15],
            },

            {
              table: {
                headerRows: 1,
                widths: ["*", 120],
                body: [
                  [
                    {
                      text: "Description / รายการ",
                      fontSize: 10,
                      bold: true,
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text: "Amount / จำนวนเงิน",
                      fontSize: 10,
                      bold: true,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ],
                  // ...this.items.slice(startIdx, endIdx).map((item) => [
                  //   {
                  //     text: item.report_desc || "",
                  //     fontSize: 9,
                  //     margin: [5, 5, 5, 5],
                  //   },
                  //   {
                  //     text:
                  //       item.report_amount && item.report_amount !== 0
                  //         ? this.formatNumber(item.report_amount)
                  //         : "",
                  //     fontSize: 9,
                  //     alignment: "right",
                  //     margin: [5, 5, 5, 5],
                  //   },
                  // ]),

                  ...this.items.slice(startIdx, endIdx).map((item) => [
                    {
                      // ← เพิ่มเงื่อนไขตรงนี้
                      text:
                        (item.first_item === 1 && item.report_type === "ADMIS"
                          ? "Miscellaneous Disbursement:\n"
                          : "") + (item.report_desc || ""),
                      fontSize: 9,
                      bold:
                        item.first_item === 1 && item.report_type === "ADMIS",
                      margin: [5, 5, 5, 5],
                    },
                    {
                      text:
                        item.report_amount && item.report_amount !== 0
                          ? this.formatNumber(item.report_amount)
                          : "",
                      fontSize: 9,
                      alignment: "right",
                      margin: [5, 5, 5, 5],
                    },
                  ]),
                ],
              },
              layout: {
                hLineWidth: function (i, node) {
                  // แสดงเส้นบนสุด, เส้นใต้ header, และเส้นล่างสุด
                  if (i === 0 || i === 1 || i === node.table.body.length) {
                    return 1;
                  }
                  return 0;
                },
                vLineWidth: function (i) {
                  return 1;
                },
                paddingLeft: function () {
                  return 0;
                },
                paddingRight: function () {
                  return 0;
                },
                paddingTop: function () {
                  return 0;
                },
                paddingBottom: function () {
                  return 0;
                },
              },
              margin: [0, 0, 0, isLastPage ? 0 : 0],
            }
          );

          // *** ถ้าเป็นหน้าสุดท้าย ให้เพิ่มผลรวมและ footer ***
          if (isLastPage) {
            mainContent.push(
              // สรุปยอดเงิน (ปรับให้มีจำนวนเงินตัวอักษรอยู่ใน table)
              {
                table: {
                  widths: ["*", 120],
                  body: [
                    [
                      {
                        text: "Sub Total / รวมเป็นเงิน",
                        fontSize: 10,
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.subtotal) +
                          +" " +
                          this.currency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, true, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.withholdingTax) +
                          +" " +
                          this.currency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                        fontSize: 10,
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text: this.formatNumber(this.vat) + " " + this.currency,
                        fontSize: 10,
                        alignment: "right",
                        border: [true, false, true, false],
                        margin: [5, 3, 5, 3],
                      },
                    ],
                    [
                      {
                        text: "Grand Total / ยอดรวม",
                        fontSize: 11,
                        bold: true,
                        fillColor: "#eeeeee",
                        border: [true, false, true, false],
                        margin: [5, 5, 5, 3],
                      },
                      {
                        text:
                          this.formatNumber(this.grandTotal) +
                          +" " +
                          this.currency,
                        fontSize: 11,
                        bold: true,
                        alignment: "right",
                        fillColor: "#eeeeee",
                        border: [true, false, true, false],
                        margin: [5, 5, 5, 3],
                      },
                    ],
                    // *** เพิ่ม: จำนวนเงินตัวอักษรในแถวใหม่ของ table ***
                    [
                      {
                        text: amountInWords,
                        fontSize: 11,
                        bold: true,
                        alignment: "center",
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 3],
                      },
                      {
                        text: "",
                        fontSize: 11,
                        bold: true,
                        alignment: "right",
                        fillColor: "#eeeeee",
                        border: [true, false, true, true],
                        margin: [5, 5, 5, 3],
                      },
                    ],
                  ],
                },
                layout: {
                  paddingLeft: function () {
                    return 0;
                  },
                  paddingRight: function () {
                    return 0;
                  },
                  paddingTop: function () {
                    return 0;
                  },
                  paddingBottom: function () {
                    return 0;
                  },
                },
                margin: [0, 0, 0, 10],
              },

              // ข้อความ Please send
              {
                stack: [
                  {
                    text:
                      "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 1],
                  },
                  {
                    text:
                      "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                    fontSize: 8,
                    alignment: "center",
                    margin: [0, 0, 0, 10],
                  },
                ],
              },

              // Disclaimer
              {
                stack: [
                  {
                    text: "Cybersecurity & Wire Transfer Disclaimer",
                    fontSize: 8,
                    bold: true,
                    color: "red",
                    margin: [0, 0, 0, 2],
                  },
                  {
                    text: disclaimerText,
                    fontSize: 7,
                    color: "red",
                    alignment: "justify",
                  },
                ],
              }
            );
          }
        }
      } else {
        // *** ถ้ามีรายการไม่เกิน 9 รายการ ให้เพิ่มผลรวมและ footer ในหน้าแรก ***
        mainContent.push(
          // สรุปยอดเงิน หน้า 1 (ปรับให้มีจำนวนเงินตัวอักษรอยู่ใน table)
          {
            table: {
              widths: ["*", 120],
              body: [
                [
                  {
                    text: "Sub Total / รวมเป็นเงิน",
                    fontSize: 10,
                    // border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.subtotal) +
                      " " +
                      this.showcurrency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, true, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย (${this.withholdingTaxRate}%)`,
                    fontSize: 10,
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.withholdingTax) +
                      " " +
                      this.showcurrency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${this.vatRate}%)`,
                    fontSize: 10,
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber(this.vat) + " " + this.currency,
                    fontSize: 10,
                    alignment: "right",
                    // border: [true, false, true, false],
                    margin: [5, 3, 5, 3],
                  },
                ],
                [
                  {
                    text: "Grand Total / ยอดรวม",
                    fontSize: 11,
                    bold: true,
                    fillColor: "#eeeeee",
                    // border: [true, false, true, false],
                    margin: [5, 5, 5, 3],
                  },
                  {
                    text:
                      this.formatNumber(this.grandTotal) +
                      " " +
                      this.showcurrency,
                    fontSize: 11,
                    bold: true,
                    alignment: "right",
                    fillColor: "#eeeeee",
                    // border: [true, false, true, false],
                    margin: [5, 5, 5, 3],
                  },
                ],
                // *** เพิ่ม: จำนวนเงินตัวอักษรในแถวใหม่ของ table ***
                [
                  {
                    text: amountInWords,
                    fontSize: 10,
                    // bold: true,
                    alignment: "center",
                    fillColor: "#eeeeee",
                    // border: [true, false, true, true],
                    margin: [5, 5, 5, 3],
                    colSpan: 2,
                  },
                  {
                    // text: "",
                    // fontSize: 11,
                    // bold: true,
                    // alignment: "right",
                    // fillColor: "#eeeeee",
                    // border: [true, false, true, true],
                    // margin: [5, 5, 5, 3],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function () {
                return 1;
              },
              vLineWidth: function () {
                return 1;
              },
              hLineColor: function () {
                return "black";
              },
              vLineColor: function () {
                return "black";
              },
              paddingLeft: function () {
                return 0;
              },
              paddingRight: function () {
                return 0;
              },
              paddingTop: function () {
                return 0;
              },
              paddingBottom: function () {
                return 0;
              },
            },
            margin: [0, 0, 0, 10],
          },

          // ข้อความ Please send
          {
            stack: [
              {
                text:
                  "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 1],
              },
              {
                text:
                  "โปรดส่งหนังสือรับรองการหักภาษีณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
                fontSize: 8,
                alignment: "center",
                margin: [0, 0, 0, 10],
              },
            ],
          },

          // Disclaimer
          {
            stack: [
              {
                text: "Cybersecurity & Wire Transfer Disclaimer",
                fontSize: 8,
                bold: true,
                color: "red",
                margin: [0, 0, 0, 2],
              },
              {
                text: disclaimerText,
                fontSize: 7,
                color: "red",
                alignment: "justify",
              },
            ],
          }
        );
      }

      return mainContent;
    },

    // ====================================================================
    // ฟังชั่นสร้าง PDF Definition ที่มีทั้ง ORIGINAL และ COPY
    // ====================================================================
    generateCombinedDocDefinitionForInvoice() {
      const originalContent = this.generateMainStatement("ORIGINAL");
      const copyContent = this.generateMainStatement("COPY");

      // เพิ่ม pageBreak ให้กับ COPY
      copyContent[0] = {
        ...copyContent[0],
        pageBreak: "before",
      };

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [25, 25, 25, 25],
        content: [...originalContent, ...copyContent],
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    async loadRef_TypeCNById() {
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      // console.log(res_docref_so.data[0]);
      const res_hresult = await api.billing_expense_getPrintDataByIdAndCusTypeInvoice_H(this.inv_id);

      if (res_hresult.data[0].company_inv == "D") {
        this.getcompany_id = 1;
        this.heighttabledetail = "499px";
        this.company_inv_prindej = "D";
        this.print_header = this.print_header_list[0];
        this.checklawoffice = false;
      } else if (res_hresult.data[0].company_inv == "L") {
        this.getcompany_id = 1;
        this.heighttabledetail = "529px";
        this.company_inv_prindej = "L";
        this.print_header = this.print_header_list[1];
        this.checklawoffice = true;
      } else {
        this.print_header.inv_company_address2 = res_hresult.data[0].inv_company_address2;
        this.print_header.inv_subdistrict = res_hresult.data[0].inv_subdistrict;
        this.print_header.inv_district = res_hresult.data[0].inv_district;
        this.print_header.inv_province = res_hresult.data[0].inv_province;
        this.print_header.inv_postcode = res_hresult.data[0].inv_postcode;
        this.print_header.inv_country = res_hresult.data[0].inv_country;

        this.getcompany_id = res_hresult.data[0].company_inv;
        this.print_header.com_name = res_hresult.data[0].com_name;
        this.print_header.inv_company_address =
          res_hresult.data[0].inv_company_address;
        this.print_header.inv_company_branch =
          res_hresult.data[0].inv_company_branch;
        this.print_header.inv_company_tel = res_hresult.data[0].inv_company_tel;
        this.print_header.inv_company_email =
          res_hresult.data[0].inv_company_email;
        this.print_header.inv_tax_id = res_hresult.data[0].inv_tax_id;
        this.print_header.inv_company_name_th =
          res_hresult.data[0].inv_company_name_th;

        if (res_hresult.data[0].inv_type == "I") {
          this.print_header.com_title = "INVOICE";
        } else if (res_hresult.data[0].inv_type == "P") {
          this.print_header.com_title = "Proforma Invoice";
        } else {
          this.print_header.com_title = "";
        }

        //   if (this.dialogSelectTitleData == "1") {
        //   this.print_header.com_title = "STATEMENT";
        //   this.print_header.com_title = "STATEMENT";
        // } else if (this.dialogSelectTitleData == "2") {
        //   this.print_header.com_title = "INVOICE";
        //   this.print_header.com_title = "INVOICE";
        // } else if(this.dialogSelectTitleData == "3"){
        //   this.print_header.com_title = "Proforma Invoice";
        //   this.print_header.com_title = "Proforma Invoice";
        // } else {
        //   this.print_header.com_title = "";
        //   this.print_header.com_title = "";
        // }
      }
      this.print_header.company_inv = this.company_inv_prindej;

      this.print_header.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.print_header.credit_term_date = res_hresult.data[0].credit_term_date;

      this.print_header.docref = res_hresult.data[0].po_no;
      this.print_header.attention = res_hresult.data[0].attention;
      this.print_header.contact_position = res_hresult.data[0].contact_position;
      this.print_header.inv_id = res_hresult.data[0].inv_id
        ? res_hresult.data[0].inv_id
        : res_hresult.data[0].pinv_id;
      this.print_header.customer_name = res_hresult.data[0].customer_name;
      this.print_header.invoice_date = res_hresult.data[0].date_show;
      this.print_header.addressall = res_hresult.data[0].addressall;
      this.print_header.customer_address = res_hresult.data[0].customer_address;

      this.print_header.province_invoice = res_hresult.data[0].province_invoice;
      this.print_header.country_invoice = res_hresult.data[0].country_invoice;
      this.print_header.zipcode_invoice = res_hresult.data[0].zipcode_invoice;

      this.print_header.period_cover = res_hresult.data[0].period_cover;
      this.print_header.customer_contact_name =
        res_hresult.data[0].customer_contact_name;
      this.print_header.customer_taxid = `${res_hresult.data[0].customer_taxid} ${(res_hresult.data[0].customer_branch && res_hresult.data[0].customer_branch !== "") ? ` / ${res_hresult.data[0].customer_branch}` : ''}`;
      this.print_header.customer_branch = res_hresult.data[0].customer_branch;

      this.print_header.ts_total = parseFloat(res_hresult.data[0].ts_total);
      this.print_header.sub_total = parseFloat(res_hresult.data[0].sub_total);
      this.print_header.wth_rate = res_hresult.data[0].wth_rate;
      this.print_header.tax_rate = res_hresult.data[0].tax_rate;
      this.print_header.wth_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].wth_rate) / 100
      );
      this.print_header.tax_rate_amount = parseFloat(
        (res_hresult.data[0].sub_total * res_hresult.data[0].tax_rate) / 100
      );

      const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      let matches = this.print_header.customer_name.match(checker_th);
      // const checker_th = /([\u0E00-\u0E7F]+)/gmu;
      if (matches) {
        this.check_cus_name = false;
      } else {
        this.check_cus_name = true;
      }

      if (this.check_cus_name) {
        this.textamount_total_en = convert.toWords(
          res_hresult.data[0].amount_total
        );

        let setcheckscratch = false;
        this.textamount_total_en = this.textamount_total_en.replace(
          /\b./g,
          function (m) {
            if (m == ",") {
              return "";
            }
            if (m == "-") {
              setcheckscratch = true;
              return m;
            } else {
              if (setcheckscratch) {
                setcheckscratch = false;
                return m;
              }
              setcheckscratch = false;
              return m.toUpperCase();
            }
          }
        );
      } else {
        var result = "";
        // อาเรย์สำหรับแปลงตัวเลขเป็นข้อความไทย
        var thaiNumbers = [
          "",
          "หนึ่ง",
          "สอง",
          "สาม",
          "สี่",
          "ห้า",
          "หก",
          "เจ็ด",
          "แปด",
          "เก้า",
        ];
        var thaiUnits = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];

        // แยกตัวจำนวนเต็มและทศนิยมห
        res_hresult.data[0].amount_total =
          Math.round(res_hresult.data[0].amount_total * 100) / 100;
        var [
          integerPart,
          decimalPart,
        ] = res_hresult.data[0].amount_total.toString().split(".");

        // แปลงส่วนทศนิยมเป็นข้อความไทย (สตางค์)
        let de_check = 0;
        if (decimalPart) {
          if (decimalPart.split("").length == 1) {
            if (Number(decimalPart) >= 10) {
              decimalPart = decimalPart;
            } else if (Number(decimalPart) > 0) {
              decimalPart = Number(decimalPart) * 10;
            } else {
              de_check = 1;
            }
          }
        } else {
          de_check = 1;
        }

        let decimalText = "";
        if (de_check == 0) {
          decimalPart = String(decimalPart);

          var numArrays = decimalPart.split("").map(Number);
          numArrays.forEach((num, index) => {
            var units = thaiUnits[numArrays.length - index - 1];
            var digits = thaiNumbers[num];
            if (num !== 0) {
              if (num === 1 && index === numArrays.length - 1) {
                // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
                decimalText += "เอ็ด" + units;
              } else if (
                num === 2 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += "ยี่" + units;
              } else if (
                num === 1 &&
                index === numArrays.length - 2 &&
                numArrays.length >= 2
              ) {
                decimalText += units;
              } else {
                decimalText += digits + units;
              }
            }
          });

          decimalText = decimalText + "สตางค์";
        }

        // แปลงส่วนจำนวนเต็มเป็นข้อความไทย
        let integerText = "";

        var numArray = integerPart.split("").map(Number);
        numArray.forEach((num, index) => {
          var unit = thaiUnits[numArray.length - index - 1];
          var digit = thaiNumbers[num];
          if (num !== 0) {
            if (num === 1 && index === numArray.length - 1) {
              // ตรวจสอบว่าเป็นตำแหน่งสุดท้าย
              integerText += "เอ็ด" + unit;
            } else if (
              num === 2 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += "ยี่" + unit;
            } else if (
              num === 1 &&
              index === numArray.length - 2 &&
              numArray.length >= 2
            ) {
              integerText += unit;
            } else {
              integerText += digit + unit;
            }
          }
        });

        integerText = integerText + "บาท";

        result = integerText + decimalText;
        this.textamount_total_en = result;
      }

      this.print_header.amount_total = parseFloat(
        res_hresult.data[0].amount_total
      );
    },
    async loadInvSoData() {
      var tmp_inv_data;
      const res_inv_so = await api.billing_expense_printInvSO(this.inv_id);

      tmp_inv_data = res_inv_so.data;
      if (tmp_inv_data.length > 0) {
        this.haveSO = true;
      }

      tmp_inv_data.forEach((inv_so, index) => {
        var data = {
          report_type: "SO",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
          solastdata: "",
        };
        if (index == tmp_inv_data.length - 1) {
          data.solastdata = "SOlastindex";
        }
        // if (index == 0) {
        //   data.first_item = 1;
        // }

        data.report_desc = inv_so.report_desc;
        data.report_amount = parseFloat(inv_so.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvDocRefData() {
      const res_inv_doc_ref = await api.billing_expense_printInvDocRef(this.inv_id);

      this.indexinvADMIS = true;

      for await (const inv_doc_ref of res_inv_doc_ref.data) {
        if (inv_doc_ref.ref_type == "AD") {
          await this.loadInvAdvanceDetailData(inv_doc_ref.ref_id);
        }

        if (inv_doc_ref.ref_type == "TS") {
          await this.loadInvTimeSheetDetailData(inv_doc_ref.ref_id);
        }
      }

      // this.dataforshowprpo = this.print_table_detail;

      // await this.checkcontent();
    },
    async loadInvTSGetTimekeeper() {
      this.datashowAlltimekeeper = [];
      if (this.print_detail_timekeeper.length <= 0) {
        return;
      }
      let data = {};
      // data.hid = this.print_detail_timekeeper;
      data.hid = [this.$route.params.id];
      const resultc = await api.billing_expense_getAllInvTSBytimesheetCreeper_hid(data);
      this.datashowAlltimekeeper = resultc.data;
      if (this.datashowAlltimekeeper.length > 0) {
        this.datashowAlltimekeeper.forEach((item) => {
          // item.tc_rateChargeHour_bath = (
          //   (Number(item.tc_actualchargehour) / 60) *
          //   Number(item.tc_rate)
          // ).toFixed(2);
          item.tc_rateChargeHour_bath = Number(item.tc_hours).toFixed(2);
          item.tc_nocharge = Math.abs(
            (
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) /
              60
            ).toFixed(2)
          );
          item.tc_nochargeCal = (
            Math.abs(
              (Number(item.tc_actualchargehour) - Number(item.tc_hours)) / 60
            ) * Number(item.tc_rate)
          ).toFixed(2);

          //sum all
          this.sum_chargehour =
            this.sum_chargehour + Number(item.tc_actualchargehour / 60);
          this.sum_rateChargehour =
            this.sum_rateChargehour + Number(item.tc_rateChargeHour_bath);
          this.sum_noCharge_hour =
            this.sum_noCharge_hour + Number(item.tc_nocharge);
          this.sum_noCharge_bath =
            this.sum_noCharge_bath + Number(item.tc_nochargeCal);
          this.sum_grandTotal = this.sum_rateChargehour;

          // //show data in table
          item.tc_rate_show = tolocalestringnumber(item.tc_rate);
          // item.tc_actualchargehour_show = tolocalestringnumber(
          //   Number(item.tc_actualchargehour / 60).toFixed(2)
          // );
          item.tc_actualchargehour_show = tolocalestringnumber(
            Number(item.tc_actualchargehour).toFixed(2)
          );
          item.tc_rateChargeHour_bath_show = tolocalestringnumber(
            item.tc_rateChargeHour_bath
          );
          item.tc_nocharge_show = tolocalestringnumber(item.tc_nocharge);
          item.tc_nochargeCal_show = tolocalestringnumber(item.tc_nochargeCal);
        });
      }
    },
    async loadInvMISData() {
      var tmp_inv_data;
      // const res_docref_so = await api.getRef_TypeCNById(this.inv_id);
      const res_inv_mis = await api.billing_expense_printInvMIS(this.inv_id);

      tmp_inv_data = res_inv_mis.data;

      tmp_inv_data.forEach((inv_mis, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };

        if (index == 0 && this.haveAD == false) {
          data.first_item = 1;
        }
        data.report_desc = inv_mis.report_desc;
        data.report_amount = parseFloat(inv_mis.report_amount);
        this.print_table_detail.push(data);
      });
    },
    async loadInvTimeSheetDetailData(ref_id) {
      var tmp_inv_data;
      this.print_detail_timekeeper.push(ref_id);
      const res_inv_time_sheet_detail = await api.billing_expense_printInvTS(ref_id);

      tmp_inv_data = res_inv_time_sheet_detail.data;

      tmp_inv_data.forEach((inv_time_sheet_detail) => {
        var data = {
          report_type: "TS",
          report_desc: "",
          report_amount: 0,
          report_date: "",
          lawyer: "",
        };

        data.report_desc = inv_time_sheet_detail.report_desc;
        data.report_amount = parseFloat(inv_time_sheet_detail.report_amount);
        data.report_date = inv_time_sheet_detail.report_date;
        data.lawyer = inv_time_sheet_detail.lawyer;
        this.print_table_detailtimesheet.push(data);
      });
    },
    async loadInvAdvanceDetailData(ref_id) {
      var tmp_inv_data;
      const res_inv_advance_detail = await api.billing_expense_printInvAD(ref_id);

      tmp_inv_data = res_inv_advance_detail.data;
      if (tmp_inv_data.length > 0) {
        this.haveAD = true;
      }

      tmp_inv_data.forEach((inv_advance_detail, index) => {
        var data = {
          report_type: "ADMIS",
          report_desc: "",
          report_amount: 0,
          first_item: 0,
        };
        if (this.indexinvADMIS == true && index == 0) {
          data.first_item = 1;
        }

        data.report_desc = inv_advance_detail.report_desc;
        data.report_amount = parseFloat(inv_advance_detail.report_amount);
        this.print_table_detail.push(data);
      });
      this.indexinvADMIS = false;
    },
    async checkcontent() {
      this.datashowAll = [];
      this.setdatatoshow = [];

      const linedetailprpo = 29; // จำนวนบรรทัดปกติต่อหน้า
      const datainlineprpo = 67; // ความยาวข้อความต่อบรรทัด
      const footerLines = 13; // บรรทัดที่ footer ใช้ (เฉพาะหน้าสุดท้าย)

      let getdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let checkamount_morethen_zero = false;

      for (let i = 0; i < this.print_table_detail.length; i++) {
        let row = this.print_table_detail[i];
        row.no = i + 1;

        let text = row.report_desc || "";
        let newhllinedetails = 0;

        // อักขระพิเศษที่ไม่กินพื้นที่
        const zeroWidthChars = [
          "่",
          "้",
          "๊",
          "๋",
          "ิ",
          "ี",
          "ึ",
          "ื",
          "ุ",
          "ู",
          "ั",
          "็",
        ];

        if (text.includes("\n")) {
          let dataarray = text.split("\n");
          for (let line of dataarray) {
            let len = line.length;
            for (let char of line) {
              if (zeroWidthChars.includes(char)) len--;
            }
            newhllinedetails += Math.ceil(len / datainlineprpo);
          }
          hllinedetails += dataarray.length - 1; // นับ newline เป็นบรรทัดเพิ่ม
        } else {
          let len = text.length;
          for (let char of text) {
            if (zeroWidthChars.includes(char)) len--;
          }
          newhllinedetails = Math.ceil(len / datainlineprpo);
        }

        // เพิ่มบรรทัดกรณีเงื่อนไขพิเศษ
        if (
          row.first_item == 1 ||
          row.solastdata == "SOlastindex" ||
          this.haveSO == false
        ) {
          newhllinedetails += 2;
        }

        if (
          i > 0 &&
          row.report_amount > 0 &&
          !checkamount_morethen_zero &&
          this.print_table_detail[i - 1].report_amount == 0
        ) {
          row.amount_morethen_zero = "yes";
          newhllinedetails += 1;
          checkamount_morethen_zero = true;
        }

        // ตรวจว่ารายการนี้เป็นรายการสุดท้ายหรือไม่
        const isLastItem = i === this.print_table_detail.length - 1;

        // ถ้ารายการสุดท้าย → ลดจำนวนบรรทัดในหน้าสุดท้ายเพื่อเผื่อ footer
        let currentPageLineLimit = linedetailprpo;
        if (isLastItem) {
          currentPageLineLimit -= footerLines;
        }

        // ถ้าเกินบรรทัดหน้าปัจจุบัน → สร้างหน้าใหม่
        if (hllinedetails + newhllinedetails > currentPageLineLimit) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;
          hllinedetails = 0;
          getdata = [];
        }

        // ใส่ข้อมูลในหน้าปัจจุบัน
        getdata.push(row);
        hllinedetails += newhllinedetails;

        // ถ้ารายการสุดท้าย → เก็บหน้าสุดท้ายไว้
        if (isLastItem) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
        }
      }

      this.opensummarize = true;

      // ทำเครื่องหมาย lastdata ในแถวสุดท้ายของหน้าสุดท้าย
      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem === this.setdatatoshow.length - 1) {
          item[item.length - 1].lastdata = "lastindex";
        }
        this.datashowAll.push(item);
      });
    },

    async checkcontenttimesheet() {
      this.datashowAlltimesheet = [];
      // alert(data.length);
      this.setdatatoshowtimesheet = [];
      let linedetailprpo = 42;
      let datainlineprpo = 60;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAlltimesheet = 1;
      let newhllinedetails = 0;
      for (let i = 0; i < this.print_table_detailtimesheet.length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.print_table_detailtimesheet[i]
          .report_desc.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.print_table_detailtimesheet[i].no = i + 1;

        for (
          let j = 0;
          j < this.print_table_detailtimesheet[i].report_desc.length;
          j++
        ) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        // newhllinedetails = Math.ceil(
        //   this.print_table_detailtimesheet[i].NAME.length / datainlineprpo
        // );

        // newhllinedetails += addnewbutget;
        getnewdata.push(this.print_table_detailtimesheet[i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
          this.pageAlltimesheet++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.print_table_detailtimesheet[i]);
          hllinedetails += newhllinedetails;
          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.print_table_detailtimesheet[i]);

          if (i == this.print_table_detailtimesheet.length - 1) {
            this.setdatatoshowtimesheet[this.pageAlltimesheet - 1] = getdata;
            getdata = [];
          }
        }
      }
      this.opensummarizetimesheet = true;

      this.setdatatoshowtimesheet.forEach((item, iitem) => {
        if (iitem == this.setdatatoshowtimesheet.length - 1) {
          item[this.setdatatoshowtimesheet[iitem].length - 1].lastdata =
            "lastindex";
        }

        this.datashowAlltimesheet.push(item);
      });
    },

    async loaddatainv() {
      this.$showLoader();
      const res_hresult = await api.billing_expense_getdataByIdInvoice_H(this.$route.params.id);
      this.statuscheck = res_hresult.data[0].status;
      const res_docref_so = await api.billing_expense_getRef_TypeSOById(this.$route.params.id);

      this.id_invoice = res_hresult.data[0].id;
      this.date = res_hresult.data[0].date;
      this.period_cover = res_hresult.data[0].period_cover;
      this.add_h.inv_id = res_hresult.data[0].inv_id;
      this.add_h.pinv_id = res_hresult.data[0].pinv_id;
      if (this.add_h.inv_id) {
        this.showinv_id = this.add_h.inv_id;
      } else if (this.add_h.pinv_id) {
        this.showinv_id = this.add_h.pinv_id;
      } else {
        this.showinv_id = "####";
      }
      if (
        res_hresult.data[0].status == "P.invoice" ||
        res_hresult.data[0].status == "Invoice" ||
        res_hresult.data[0].status == "Credit Note" ||
        res_hresult.data[0].status == "Receive"
      ) {
        // this.datainv_disable = true;
        // this.ts_status_oper = "Submit";
      } else {
        // this.ts_status_oper = "draft";
      }
      if (res_hresult.data[0].inv_type == "P") {
        this.titleheader = "P.Invoice";
      } else if (res_hresult.data[0].inv_type == "I") {
        this.titleheader = "Invoice";
      }

      this.add_h.inv_type = res_hresult.data[0].inv_type;
      this.add_h.customerid = res_hresult.data[0].customer_id;
      this.add_h.customer_address = res_hresult.data[0].customer_address;
      this.add_h.customer_taxid = res_hresult.data[0].customer_taxid;
      this.add_h.customer_branch = res_hresult.data[0].customer_branch;
      this.add_h.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.add_h.customer_vat = res_hresult.data[0].customer_vat;
      this.add_h.vat_type = res_hresult.data[0].vat_type;
      this.add_h.company_inv = res_hresult.data[0].company_inv;
      if (res_hresult.data[0].additional_top != "" && res_hresult.data[0].additional_top) {
        this.filename_old = [];
        this.filename_old = res_hresult.data[0].additional_top.split(",");
        this.add_h.additional_top = res_hresult.data[0].additional_top;
      }

      this.add_h.additional_bottom = "";

      this.getdatefrom_inv_h.customerid = res_hresult.data[0].customer_id;
      this.getdatefrom_inv_h.customer_code = res_hresult.data[0].customer_code;
      this.getdatefrom_inv_h.customer_name = res_hresult.data[0].customer_name;
      this.getdatefrom_inv_h.po_no = res_hresult.data[0].po_no;
      this.getdatefrom_inv_h.attention = res_hresult.data[0].attention;
      this.getdatefrom_inv_h.contact_position =
        res_hresult.data[0].contact_position;
      this.getdatefrom_inv_h.customer_address =
        res_hresult.data[0].customer_address;
      this.getdatefrom_inv_h.customer_taxid =
        res_hresult.data[0].customer_taxid;
      this.getdatefrom_inv_h.customer_branch =
        res_hresult.data[0].customer_branch;
      this.getdatefrom_inv_h.customer_paymentterm =
        res_hresult.data[0].customer_paymentterm;
      this.getdatefrom_inv_h.customer_vat = res_hresult.data[0].customer_vat;
      this.getdatefrom_inv_h.vat_type = res_hresult.data[0].vat_type;
      this.getdatefrom_inv_h.currency = res_hresult.data[0].currency;
      this.showcurrency = res_hresult.data[0].currency;
      this.showcurrency = this.showcurrency.replace("US", "USD");
      this.showcurrency = this.showcurrency.replace("USDD", "USD");

      this.getdatefrom_inv_h.saleorder_id = res_hresult.data[0].saleorder_id;
      this.getdatefrom_inv_h.dept = res_hresult.data[0].dept
        ? res_hresult.data[0].dept
        : 0;
      this.getdatefrom_inv_h.dept_type = res_hresult.data[0].dept_type;
      this.getuser_create = res_hresult.data[0].user_create
        ? res_hresult.data[0].user_create
        : 0;
      if (res_docref_so.data[0]) {
        // this.getdatefrom_inv_h.saleorder_id =
        //   res_docref_so.data[0].saleorder_id;
      }

      this.inv_subtotal = res_hresult.data[0].sub_total;
      this.wth_rate = res_hresult.data[0].wth_rate;
      this.tax_rate = res_hresult.data[0].tax_rate;
      this.amount_total = res_hresult.data[0].amount_total;
      this.amount_total = tolocalestringnumber(this.amount_total);
      this.so_total = res_hresult.data[0].so_total;
      this.so_total = tolocalestringnumber(this.so_total);
      this.ts_total = res_hresult.data[0].ts_total;
      this.ts_total = tolocalestringnumber(this.ts_total);
      this.ad_total = res_hresult.data[0].ad_total;
      this.ad_total = tolocalestringnumber(this.ad_total);
      this.mis_total = res_hresult.data[0].mis_total;
      this.mis_total = tolocalestringnumber(this.mis_total);

      const res_misresult = await api.billing_expense_getdataByIdInv_Mis(this.$route.params.id);
      this.datainv_mis = res_misresult.data;

      this.calgrandtotal();
      // this.caltotalAll();
      // this.calwth_rate();
      // this.caltax_rate();

      const res_soresult = await api.billing_expense_getdataByIdInv_SO(this.$route.params.id);
      this.getdatefrom_inv_so = res_soresult.data;

      const res_tsid = await api.billing_expense_getTs_hListId(this.$route.params.id);
      const dataAllTsId = res_tsid.data;

      let indexAD = 0;
      let indexTS = 0;
      if (dataAllTsId.length > 0) {
        for (let i = 0; i < dataAllTsId.length; i++) {
          if (dataAllTsId[i].ref_type == "TS") {
            this.ts_id[indexTS] = dataAllTsId[i].ref_id;
            indexTS += 1;
          } else if (dataAllTsId[i].ref_type == "AD") {
            this.ad_id[indexAD] = dataAllTsId[i].ref_id;
            indexAD += 1;
          }
        }
      }
      this.ts_idTab = this.ts_id;
      this.ad_idTab = this.ad_id;
      this.ad_inv_id = this.ad_id;
      if (this.getdatafrominv_h == true) {
        this.getdataByCusStatus = "INV";
      }
      this.callsoopentab = true;
      this.$hideLoader();
    },
    async saveinvDraftandSubmit(mode) {
      this.add_h.customer_paymentterm = this.payment_term_cus;
      this.add_h.customer_vat = this.vat_cus;
      this.add_h.po_no = this.po_no_cus;
      this.add_h.attention = this.attention_cus;
      this.add_h.contact_position = this.contact_position_cus;
      this.add_h.vat_type = this.vat_type_cus;
      this.add_h.inv_date = this.date;
      this.add_h.period_cover = this.period_cover;
      this.add_h.so_total = parseFloat(
        stringcommatonumber(this.so_total.toString())
      );
      this.add_h.ts_total = parseFloat(
        stringcommatonumber(this.ts_total.toString())
      );
      this.add_h.ad_total = parseFloat(
        stringcommatonumber(this.ad_total.toString())
      );
      this.add_h.mis_total = parseFloat(
        stringcommatonumber(this.mis_total.toString())
      );
      this.add_h.sub_total = parseFloat(
        stringcommatonumber(this.inv_subtotal.toString())
      );
      this.add_h.wth_rate = parseFloat(this.wth_rate);
      this.add_h.tax_rate = parseFloat(this.tax_rate);
      this.add_h.amount_total = parseFloat(
        stringcommatonumber(this.amount_total.toString())
      );
      this.add_h.so_ref = this.$route.params.id;

      this.$showLoader();
      if (this.getdatafrominv_h == true) {
        let formData = new FormData();

        this.image_list.forEach((x, index) => {
          formData.append(`file`, x);
        });

        let res_up_file = await api.billing_expense_addInvoice_HFile(
          this.$route.params.id,
          formData
        );


        const newfile = res_up_file.data;
        const combinedFiles = [
          ...(this.filename_old || []),
          ...(newfile || [])
        ];

        var file_all = "";
        file_all = combinedFiles.length > 1
          ? combinedFiles.join(",")
          : combinedFiles[0] ?? "";

        this.add_h.additional_top = file_all;

        var del_file = "";
        del_file = this.delfilename_old.length > 1
          ? this.delfilename_old.join(",")
          : this.delfilename_old[0] ?? "";

        this.add_h.del_additional_top = del_file;

        this.add_h.additional_bottom = "";

        let update_hresult = [];
        if (mode == "Update") {
          update_hresult = await api.billing_expense_updateInvoice_H(
            this.$route.params.id,
            this.add_h
          );
        } else {
          return;
        }

        //add so
        if (update_hresult.status == 200 || update_hresult.status == 201) {
          await api.billing_expense_deleteInv_SO(this.$route.params.id);
          this.desserts.forEach((x, index) => {
            this.addinv_so.inv_hid = this.$route.params.id;
            this.addinv_so.so_seq = index + 1;
            this.addinv_so.item_name = x.description;
            this.addinv_so.item_qty = parseFloat(
              stringcommatonumber(x.unit.toString())
            );
            this.addinv_so.item_price = parseFloat(
              stringcommatonumber(x.PricePerUnit.toString())
            );
            this.addinv_so.item_line_amt = parseFloat(
              stringcommatonumber(x.amount.toString())
            );
            api.billing_expense_addInv_SO(this.addinv_so);
          });

          //add mis
          await api.billing_expense_deleteInv_Mis(this.$route.params.id);
          this.datainv_mis.forEach(async (data, index) => {
            data.inv_hid = this.$route.params.id;
            data.mis_seq = index + 1;
            data.amount = parseFloat(
              stringcommatonumber(data.amount.toString())
            );
            await api.billing_expense_addInv_Mis(data);
          });

          //add advance
          await api.billing_expense_delete_docrefAD(this.$route.params.id);
          if (this.ad_inv_id.length > 0) {
            for (let i = 0; i < this.ad_inv_id.length; i++) {
              await api.billing_expense_updateAdvanceH(this.ad_inv_id[i], { status: 9 });
            }
            if (this.ad_id.length > 0) {
              for (let i = 0; i < this.ad_id.length; i++) {
                this.addinv_docref_ad.inv_hid = this.$route.params.id;
                this.addinv_docref_ad.ref_id = this.ad_id[i];
                await api.billing_expense_addInv_Docref(this.addinv_docref_ad);
                //stam status Advance_H = 10 Invioce
                await api.billing_expense_updateAdvanceH(this.ad_id[i], { status: 10 });
              }
            }
          } else {
            if (this.ad_id.length > 0) {
              for (let i = 0; i < this.ad_id.length; i++) {
                this.addinv_docref_ad.inv_hid = this.$route.params.id;
                this.addinv_docref_ad.ref_id = this.ad_id[i];
                await api.billing_expense_addInv_Docref(this.addinv_docref_ad);
                //stam status Advance_H = 10 Invioce
                await api.billing_expense_updateAdvanceH(this.ad_id[i], { status: 10 });
              }
            }
          }

          //add inv ts
          if (this.inv_ts_list.length > 0) {
            await api.billing_expense_deleteInvTS(this.$route.params.id);
            for (let i = 0; i < this.inv_ts_list.length; i++) {
              let addDataInvTS = {};
              addDataInvTS.inv_hid = this.$route.params.id;
              addDataInvTS.user_id = this.inv_ts_list[i].emp_id;
              addDataInvTS.emp_rate = Number(this.inv_ts_list[i].tc_rate);
              addDataInvTS.tc_actualchargehour = Number(
                this.inv_ts_list[i].tc_actualchargehour_show
              );
              addDataInvTS.tc_ratechargehour_bath = Number(
                this.inv_ts_list[i].tc_rateChargeHour_bath
              );
              let req_addInvTS = await api.billing_expense_addInvTS(addDataInvTS);
              if (req_addInvTS.status == 200 || req_addInvTS.status == 201) {
                //add sucess
              } else {
                await api.billing_expense_deleteInvTS(this.$route.params.id);
                break;
              }
            }
          }

          //add doc_ref
          await api.billing_expense_delete_docrefTS(this.$route.params.id);
          if (this.ts_id) {
            if (this.ts_id.length > 0) {
              for (let i = 0; i < this.ts_id.length; i++) {
                this.addinv_docref_ts.inv_hid = this.$route.params.id;
                this.addinv_docref_ts.ref_id = this.ts_id[i];

                await api.billing_expense_addInv_Docref(this.addinv_docref_ts);
              }
            }
          }
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            `/reloadpage`
          );
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
        }
      }
    },

    async getdatafromSOcomponent(
      customer_id,
      invoice_address,
      tax_id,
      branch,
      payment_term,
      vat,
      vat_type,
      testsumso,
      so_hid
    ) {
      if (this.getdatafrominv_h === false) {
        if (!payment_term) {
          payment_term = 0;
        }
        this.so_total = testsumso;
        this.so_total = tolocalestringnumber(this.so_total);
        this.tax_rate = vat;
        this.add_h.customerid = customer_id;
        this.add_h.customer_address = invoice_address;
        this.add_h.customer_taxid = tax_id;
        this.add_h.customer_branch = branch;
        this.add_h.customer_paymentterm = payment_term;
        this.add_h.customer_vat = vat;
        this.add_h.vat_type = vat_type;
        this.invoice_address = invoice_address;
        this.addinv_docref_so.ref_id = so_hid;
      }

      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromSOtable(dataintable) {
      this.desserts = dataintable;
    },
    async getdatafromTStotal(TStotal) {
      this.ts_total = TStotal;
      this.ts_total = tolocalestringnumber(this.ts_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromAdtotal(Adtotal) {
      this.ad_total = Adtotal;
      this.ad_total = tolocalestringnumber(this.ad_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getTsId(TS_ID) {
      this.ts_id = TS_ID;
    },
    async getAdId(AS_ID) {
      this.ad_id = AS_ID;
    },
    async getAdInvioceId(AD_Invioce_Id) {
      this.ad_inv_id = AD_Invioce_Id;
    },
    async getSelected_showE(Selected_ShowE) {
      this.selected_showE = Selected_ShowE;
    },
    async getmode_oper_ts(modets) {
      this.mode_oper = modets;
    },
    async getOper_sel(Oper_Sel) {
      this.oper_sel = Oper_Sel;
    },
    async getInvTsList(invTs_List) {
      this.inv_ts_list = invTs_List;
    },
    async getSelected_showEAv(Selected_ShowAv) {
      this.selected_showAv = Selected_ShowAv;
    },
    async getOper_selAv(Oper_SelAv) {
      this.oper_sel_Av = Oper_SelAv;
    },
    async getdatafromSOisheader(testsumso) {
      this.so_total = testsumso;
      this.so_total = tolocalestringnumber(this.so_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },

    async getdatafromMis(data) {
      this.mis_total = 0;
      this.datainv_mis = [];
      this.datainv_mis = data;
      this.datainv_mis.forEach((x, index) => {
        x.amount = parseFloat(stringcommatonumber(x.amount.toString()));
        this.mis_total += parseFloat(x.amount);
      });
      this.mis_total = tolocalestringnumber(this.mis_total);
      this.caltotalAll();
      this.calwth_rate();
      this.caltax_rate();
    },
    async getdatafromadditional(data) {
      this.add_h.additional_top = data.additional_top;
      this.add_h.additional_bottom = data.additional_bottom;
    },

    caltotalAll() {
      // this.inv_subtotal =
      //   parseFloat(stringcommatonumber(this.so_total.toString())) +
      //   parseFloat(stringcommatonumber(this.ts_total.toString())) +
      //   parseFloat(stringcommatonumber(this.ad_total.toString())) +
      //   parseFloat(stringcommatonumber(this.mis_total.toString()));
      // this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);
      this.calgrandtotal();
    },
    tabClicked(selectedTab) {
      // console.log("Current tab re-clicked:" + selectedTab.tab.name);
    },
    tabChanged(selectedTab) {
      // console.log("Tab changed to:" + selectedTab.tab.name);
    },
    closeDelete() { },
    deleteItemConfirm() { },
    calwth_rate() {
      // this.wth_ratetotal = parseFloat(
      //   (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
      //     parseFloat(stringcommatonumber(this.wth_rate.toString()))) /
      //     100
      // );
      // this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);
      this.calgrandtotal();
    },
    caltax_rate() {
      // this.tax_ratetotal = parseFloat(
      //   (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
      //     parseFloat(stringcommatonumber(this.tax_rate.toString()))) /
      //     100
      // );
      // this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
      this.calgrandtotal();
    },

    calgrandtotal() {
      this.inv_subtotal =
        parseFloat(stringcommatonumber(this.so_total.toString())) +
        parseFloat(stringcommatonumber(this.ts_total.toString())) +
        parseFloat(stringcommatonumber(this.ad_total.toString())) +
        parseFloat(stringcommatonumber(this.mis_total.toString()));
      this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);

      if (this.add_h.vat_type == "E") {
        this.tax_ratetotal = parseFloat(
          (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
            parseFloat(stringcommatonumber(this.tax_rate.toString()))) /
          100
        );
        this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
        this.wth_ratetotal = parseFloat(
          (parseFloat(stringcommatonumber(this.inv_subtotal.toString())) *
            parseFloat(stringcommatonumber(this.wth_rate.toString()))) /
          100
        );
        this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);

        this.amount_total = parseFloat(
          parseFloat(stringcommatonumber(this.inv_subtotal.toString())) -
          parseFloat(stringcommatonumber(this.wth_ratetotal.toString())) +
          parseFloat(stringcommatonumber(this.tax_ratetotal.toString()))
        ).toFixed(2);
        this.amount_total = tolocalestringnumber(this.amount_total);
      } else if (this.add_h.vat_type == "I") {
        this.amount_total =
          stringcommatonumber(this.inv_subtotal) / (1 + this.wth_rate / 100);
        this.wth_ratetotal = (
          stringcommatonumber(this.inv_subtotal) - this.amount_total
        ).toFixed(2);
        this.inv_subtotal = (
          this.amount_total /
          (1 + this.tax_rate / 100)
        ).toFixed(2);
        this.tax_ratetotal = (this.amount_total - this.inv_subtotal).toFixed(2);

        this.amount_total = tolocalestringnumber(this.amount_total);
        this.inv_subtotal = tolocalestringnumber(this.inv_subtotal);
        this.tax_ratetotal = tolocalestringnumber(this.tax_ratetotal);
        this.wth_ratetotal = tolocalestringnumber(this.wth_ratetotal);
      } else {
      }
    },
    async deleteItemConfirmForm() {
      if (this.getdatafrominv_h == true) {
        this.$showLoader();
        // await api.deleteInvoice_H(this.$route.params.id);
        // await api.deleteInv_SO(this.$route.params.id);
        // await api.delete_docrefTS(this.$route.params.id);
        // await api.delete_docrefAD(this.$route.params.id);
        // await api.delete_docrefSO(this.$route.params.id);
        // await api.deleteInvTS(this.$route.params.id);

        // if (this.ad_inv_id.length > 0) {
        //   for (let i = 0; i < this.ad_inv_id.length; i++) {
        //     await api.updateAdvanceH(this.ad_inv_id[i], { status: 9 });
        //   }
        // }
        await api.billing_expense_updateInvoice_H(this.$route.params.id, { status: 4 });
        this.$hideLoader();
        this.dialogDeleteForm = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "บันทึกข้อมูล",
          "บันทึกข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/adjust-invoice"
        );
      } else {
        this.dialogDeleteForm = false;
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "ลบข้อมูล",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
          "/invoice"
        );
      }
    },
    async closeDeleteForm() {
      this.dialogDeleteForm = false;
    },
    setupAlertDialog(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async getdatavatcus(VAT_CUS) {
      this.vat_cus = VAT_CUS;
      // alert(this.vat_cus)
    },
    async getdatapaymentcus(payment_CUS) {
      this.payment_term_cus = payment_CUS;
      this.add_h.customer_paymentterm = payment_CUS;
      // alert(this.payment_term_cus)
    },
    async getdataPonoCus(PONO_CUS) {
      this.po_no_cus = PONO_CUS;
      // alert(this.po_no_cus)
    },
    async getdataAttentionCus(attention) {
      this.attention_cus = attention;
    },
    async getdatacontact_positionCus(contact_position) {
      this.contact_position_cus = contact_position;
    },
    async getdatavat_type(vat_type) {
      this.vat_type_cus = vat_type;
      this.add_h.vat_type = vat_type;
      this.calgrandtotal();
    },
    //---------------function file------------//
    async popupdeletefile(index) {
      this.fileindex = index;
      this.dialogDelete = true;
    },

    async popupdeletefile_old(index) {
      this.old_index = index;
      this.dialogDelete_old = true;
    },

    async closeDelete() {
      this.fileindex = -1;
      this.dialogDelete = false;
    },

    async closeDelete_old() {
      this.old_index = -1;
      this.dialogDelete_old = false;
    },
    async deleteItemConfirm() {
      this.preview_list2 = [];
      this.getpreview_list.splice(this.fileindex, 1);
      this.image_list.splice(this.fileindex, 1);
      await this.getPdfforAdd(this.getpreview_list);

      this.filename.splice(this.fileindex, 1);
      this.preview_list2 = this.preview_list;
      this.fileindex = -1;
      this.dialogDelete = false;
    },
    async deleteItemConfirm_old() {
      this.dialogDelete_old = false;
      this.delfilename_old.push(this.filename_old[this.old_index])
      this.filename_old.splice(this.old_index, 1);
    },
    async popupdeleteimage() {
      this.dialogDeleteimage = true;
    },
    async closeDeleteimage() {
      this.dialogDeleteimage = false;
    },
    async deleteItemConfirmimage() {
      this.checkimageadd = false;
      this.image = null;
      this.previewimage = "";
      this.imagename = "";
      this.dialogDeleteimage = false;
    },
    async previewnoticefilepdf(file_name) {
      this.previewpopupfile2 = [];

      let file_name_s = file_name;
      let pdf_newTab = window.open(
        `${INVUrl}/${this.$route.params.id}/${file_name_s}`
      );

      return;
    },
    async popuppreviewfile(fileindex) {
      const file = this.image_list[fileindex];
      if (!file) return;

      // เช็คว่าเป็น PDF จริง
      if (file.type !== "application/pdf") {
        alert("ไฟล์นี้ไม่ใช่ PDF");
        return;
      }

      const fileUrl = URL.createObjectURL(file);

      // เปิดใหม่แบบปกติเลย (ไม่ต้อง document.write)
      window.open(fileUrl, "_blank");
    },
    async closepreviewfile() {
      this.dialogpreviewfile = false;
    },
    async popuppreviewimage() {
      this.dialogpreviewimage = true;
    },
    async closepreviewimage() {
      this.dialogpreviewimage = false;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewimage = e.target.result;
          this.checkimageadd = true;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }

      this.imagename = this.image.name;
    },
    async previewMultiImage(event) {
      this.filename = [];
      this.preview_list = [];
      this.getpreview_list = [];
      // this.image_list = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;

      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.getpreview_list.push(e.target.result);
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type === "application/pdf") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }

      await this.getPdfforAdd(this.getpreview_list);

      this.preview_list2 = this.preview_list;

      this.image_list.forEach((x, index) => {
        this.filename.push(x.name);
      });

      this.checkfileeadd = true;
    },

    reset: function () {
      this.image = null;
      this.previewimage = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async getPdfforpreview(datafile) {
      this.previewpopupfile = [];
      let getfile = [];
      getfile = datafile;
      this.previewpopupfile.push(pdfvuer.createLoadingTask(`${getfile}`));
      this.previewpopupfile.forEach((item, index) => {
        item.then((pdf) => {
          this.numPagespreview = pdf.numPages;
        });
      });
    },

    async getPdfforAdd(item) {
      this.preview_list = [];
      let getfile = [];
      getfile = item;
      getfile.forEach((file, index) => {
        this.preview_list.push(pdfvuer.createLoadingTask(`${file}`));
      });
      this.preview_list.forEach((item, index) => {
        item.then((pdf) => {
          this.numPages = pdf.numPages;
          // window.onscroll = function() {
          //   changePage();
          //   stickyNav();
          // };
          // Get the offset position of the navbar
          // var sticky = $("#buttons")[0].offsetTop;
          // // Add the sticky class to the this.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
          // function stickyNav() {
          //   if (window.pageYOffset >= sticky) {
          //     $("#buttons")[0].classList.remove("hidden");
          //   } else {
          //     $("#buttons")[0].classList.add("hidden");
          //   }
          // }
          function changePage() {
            var i = 1,
              count = Number(pdf.numPages);
            do {
              if (
                window.pageYOffset >=
                this.findPos(document.getElementById(i)) &&
                window.pageYOffset <=
                this.findPos(document.getElementById(i + 1))
              ) {
                this.page = i;
              }
              i++;
            } while (i < count);
            if (
              window.pageYOffset >= this.findPos(document.getElementById(i))
            ) {
              this.page = i;
            }
          }
        });
      });
      this.checkfileadd = true;
    },
    handle_pdf_link: function (params) {
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
      var page = document.getElementById(String(params.pageNumber));
      page.scrollIntoView();
    },
    findPos(obj) {
      return obj.offsetTop;
    },
    //--------------------end funcfile--------------------//
  },
  beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  line-height: 1.5;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  font-family: "Roboto", sans-serif;
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred100 {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captiontotal {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.8;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-5prpo {
  margin-top: -5px !important;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt20 {
  margin-top: 20px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-20prpo {
  margin-top: -20px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.ml-40prpo {
  margin-left: -40px !important;
}

.borderblockpr {
  border: 1px solid black;
  width: 300px;
  height: 80px;
  /* background: white; */
  /* box-sizing: border-box; */
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

.textaligncenter {
  text-align: center;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  /* border-top: 1px solid black; */
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 1px solid black;
}

td {
  /* border: 1px solid black; */
}

td.tdborder-top {
  border-top: 1px solid black;
}

td.tdborder-right {
  border-right: 1px solid black;
}

td.tdborder-left {
  border-left: 1px solid black;
}

td.tdborder-bottom {
  border-bottom: 1px solid black;
}

th {
  /* border: 1px solid black; */
}

th.thborder-top {
  border-top: 1px solid black;
}

th.thborder-right {
  border-right: 1px solid black;
}

th.thborder-left {
  border-left: 1px solid black;
}

th.thborder-bottom {
  border-bottom: 1px solid black;
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width75 {
  word-wrap: break-word;
  width: 75%;
}

.width80 {
  word-wrap: break-word;
  width: 80%;
}

.width85 {
  word-wrap: break-word;
  width: 85%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width98 {
  word-wrap: break-word;
  width: 98%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
            body.A3.landscape { width: 420mm }
            body.A3, body.A4.landscape { width: 297mm }
            body.A4, body.A5.landscape { width: 210mm }
            body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixfourrow {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  height: 80px;
  overflow: hidden;
  text-align: left;
}

.fixthreerow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 60px;
  overflow: hidden;
  text-align: left;
}

.fixthreerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerownoheight {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fixonerowcenter {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: center;
}

.fontsize10 {
  font-size: 10px;
}

.fontsize12 {
  font-size: 12px;
}

.fontsize13 {
  font-size: 13px;
}

.fontsize14 {
  font-size: 14px;
}

.borderwidththin {
  border-width: thin;
  border-color: darkgray;
}

.titledatadetailintable {
  font-weight: bold;
  text-decoration: underline;
}

.paddingleftintable {
  padding-left: 10px;
}

.paddingrightintable {
  padding-right: 10px;
}

.v-text-field.v-text-field--enclosed .v-text-field__details .cutdetailtextfield {
  padding-top: 0px;
  margin-bottom: -25px;
}

.v-application a {
  color: white;
}

.containertab {
  max-width: 100%;
  min-width: 100%;
  margin: 40px auto;
  /* font-family: Arial, Helvetica, sans-serif; */
  font-size: 0.9em;
  color: #888;
}

.tabs {
  overflow: hidden;
  /* margin-left: 20px; */
  margin-bottom: -2px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a {
  float: left;
  cursor: pointer;
  padding: 10px 24px;
  transition: background-color 0.2s;
  border: 1px solid #595959;
  /* border-right: none; */
  border-right: 1px solid #595959;
  background-color: #595959;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}

/* .tabs a:last-child {
    border-right: 1px solid #595959;
  } */

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  border: 1px solid #595959;
  /* border-radius: 10px; */
  border-radius: 0px 10px 10px 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
}

.btn-width {
  width: 120px;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.width16 {
  width: 16%;
}

.widthsubtotal {
  width: 18%;
}

.widthsubtotalG {
  width: 36%;
}

.widthplus {
  width: 4%;
}

.widthsub {
  width: 6%;
}

.widthgrandnull {
  width: 102%;
}

.widthspace {
  width: 4%;
}

.widthglessword {
  width: 60%;
}

.widthlesspersen {
  width: 12%;
}

.widthtextpersen {
  width: 8%;
}

.widthlesstotal {
  width: 16%;
}

.wordspacingsummary {
  /* word-spacing: -1px; */
  letter-spacing: 1px;
}

.fontweight700 {
  font-weight: 700;
}

.col-md-6report55 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 55%;
  flex: 0 0 55%;
  max-width: 55%;
}

.col-md-6report45 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 45%;
  flex: 0 0 45%;
  max-width: 45%;
}

.col-md-2report20 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}

.col-md-10report80 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 80%;
  flex: 0 0 80%;
  max-width: 80%;
}

.col-md-3report27 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 27%;
  flex: 0 0 27%;
  max-width: 27%;
}

.col-md-9report73 {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 73%;
  flex: 0 0 73%;
  max-width: 73%;
}

.doubleunderline {
  /* text-decoration-line: underline;
    text-decoration-style: double; */
  border-bottom: 3px double #000000;
  border-top: 1px double #000000;
  /* text-underline-offset: 4px; */
  /* padding-bottom:4px;
    height: 1px; */
}
</style>
